import React from 'react';
import ReactModal from 'react-modal';
import { ModalStyle, OverlayStyle } from './Modal.styles';

const Modal = ({ isOpen, children, onClose, shouldCloseOnOverlayClick = true, onAfterClose = () => {} }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      onAfterClose={onAfterClose}
      className="_"
      overlayClassName="_"
      contentElement={props => <ModalStyle {...props}>{children}</ModalStyle>}
      overlayElement={(props, contentElement) => <OverlayStyle {...props}>{contentElement}</OverlayStyle>}
      ariaHideApp={false}
      shouldCloseOnEsc={shouldCloseOnOverlayClick}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    />
  );
};

export default Modal;
